import React, { Component } from "react";
import { connect } from "react-redux";
import { getUserWithId } from "../../../store/users/selectors";
import { fetchUser } from "../../../store/users/operations";
import { NO_USER_PHOTO_URL } from "../../../config.js";

export class UserImage extends Component {
  componentDidMount() {
    this.props.fetchUser(this.props.userGuid);
  }
  render() {
    let user_image = NO_USER_PHOTO_URL;
    if (this.props.user) {
      user_image = this.props.user["image_url"] ? this.props.user["image_url"] : NO_USER_PHOTO_URL;
    }

    return (
      <div className="image user-avatar size-32">
        {this.props.user && <img src={user_image} alt={this.props["user"]["f_name"]} />}
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    locale: state.i18n.locale,
    user: getUserWithId(state, ownProps.userGuid)
  };
};

const mapDispatchToProps = dispatch => ({
  fetchUser: userGuid => dispatch(fetchUser(userGuid))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(UserImage);
